import "../../../../assets/presentation/components/layout/blocking-view/blocking-view-VYk_uBVN.css";
import { Conditional } from "../../components.js";
import throbber_default from "../../../../assets/throbber.js";
/* empty css              */
import classNames from "classnames";
import React, { createElement, useEffect, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/layout/blocking-view/blocking-view.tsx
var BlockingViewScrim = ({ isBlocked, isPending = false, isVisible, loadingText = "Cargando" }) => {
	return /* @__PURE__ */ jsx(Conditional, {
		condition: isPending || isBlocked || isVisible,
		children: /* @__PURE__ */ jsxs("div", {
			className: "scrim",
			children: [/* @__PURE__ */ jsx("img", {
				src: throbber_default,
				alt: "throbber"
			}), /* @__PURE__ */ jsx("span", {
				className: "label-text",
				children: loadingText
			})]
		})
	});
};
var BlockingView = ({ children, className, component, isPending = false, onSubmit, testId, style, id, onClickOutside, loadingText }) => {
	const [isVisible, setIsVisible] = useState(false);
	const [isBlocked, setIsBlocked] = useState(false);
	const componentRef = useRef(null);
	useEffect(() => {
		if (isPending) {
			const timeOut = setTimeout(() => {
				setIsVisible(true);
			}, 5);
			setIsBlocked(true);
			return () => {
				clearTimeout(timeOut);
			};
		} else {
			const timeOut = setTimeout(() => {
				setIsBlocked(false);
			}, 1e3);
			setIsVisible(false);
			return () => {
				clearTimeout(timeOut);
			};
		}
	}, [isPending, setIsVisible]);
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (componentRef.current && !componentRef.current.contains(event.target)) {
				if (onClickOutside) onClickOutside();
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [onClickOutside]);
	return createElement(component, {
		"className": classNames(className, "blocking-view", {
			blocked: isBlocked,
			pending: isPending,
			visible: isVisible
		}),
		id,
		"data-testid": testId,
		onSubmit,
		"ref": componentRef,
		style
	}, /* @__PURE__ */ jsxs(React.Fragment, { children: [children, /* @__PURE__ */ jsx(BlockingViewScrim, {
		isBlocked,
		isPending,
		isVisible,
		loadingText
	})] }));
};
//#endregion
export { BlockingView, BlockingViewScrim };

//# sourceMappingURL=blocking-view2.js.map